/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
var commonHelper = require('../helpers/dynpack_common');

function getActivatedTags(response) {
    return {
        'activatedTags': commonHelper.getValidateActivateTags.call(this, response),
    };
}

function getValidData(response) {
    var accommodationSearchResultsMetadata = Odigeo._.pick(response.accommodationSearchResultsMetadata,
        'numFilteredResults',
        'numResults');
    accommodationSearchResultsMetadata = Odigeo._.extend(accommodationSearchResultsMetadata, Odigeo._.pick(response.locationDestination,
        'city'));

    return this.opts.hasActivedTags ?
        Odigeo._.extend({}, accommodationSearchResultsMetadata, getActivatedTags.call(this, response)) :
        accommodationSearchResultsMetadata;
}

module.exports = Odigeo.Model.extend({
    defaults: {
        numResults: Infinity,
        numFilteredResults: Infinity,
        cheapestAccommodationPrice: 0,
        activatedTags: {},
        city: '',
    },

    init: function() {
        this.opts = Odigeo.Utils.parseOptions(this.widget.options);
    },

    update: function(response) {
        this.set(getValidData.call(this, response));
    },
});

